module.exports = "/static/assets/7382ef4a40ab40e4fec38b912a5c9ad7.png";